import {post_request} from "../axiosFun"

//区域线路列表
export const get_region_list = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            map_name:params.map_name_cn,
            line_name:params.line_name_cn,
            page_no:params.page,
            page_size:params.limit
        }
    }
    return post_request("/web/area/get_area_line",params)
};
//导入线路
export const area_bind_line = (params,strs) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            map_id:params.map_id,
            line_ids:strs,
        }
    }
    return post_request("/web/area/area_bind_line",params)
};
//添加地图列表
export const get_area_map = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id")
        }
    }
    return post_request("/web/area/area_map",params)
};
//添加线路列表
export const get_area_map_line = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            map_id:params.map_id
        }
    }
    return post_request("/web/area/area_map_line",params)
};
//获取单条线路信息
export const get_area_line_one = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            line_id:params
        }
    }
    return post_request("/web/area/get_area_line_one",params)
};
//修改线路信息
export const get_area_line_edit = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            line_id:params.id,
            remark:params.remark
        }
    }
    return post_request("/web/area/area_line_edit",params)
};
//线路详情
export const get_area_line_detail = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            line_id:params

        }
    }
    return post_request("/web/area/area_line_detail",params)
};
//删除区域线路
export const get_del_area_line = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            line_id:params
        }
    }
    return post_request("/web/area/area_unbind_line",params)
};


// WEBPACK FOOTER //
// ./src/api/region/area_line.js